import T6 from '../../components/ExcerciseTypes/TypeIn/T6';

const json = {
  1: { // Exercise num
    unit: 'Unit 12',
    id: 'WB3-U12-P81-E1',
    audio: '',
    video: '',
    component: T6,
    stylesTextInput: { backgroundColor: 'transparent', border: 'none', padding: 0 },
    exerciseKey: 'img/FriendsPlus/Page81/E1/Key/answerKey.png',
    inputSize: 435,
    checkUppercase: true,
    // titleImage: "img/FriendsPlus/Page60/E1/1.jpg",
    // titleQuestion: [{ num: '1', title: 'Read the sentences and number the picture.', color: "#5B5A5D" }],
    questionImage: [],
    questions: [
      {
        title: `
        <div style=" position: relative; ">
          <div> <img src='img/FriendsPlus/Page81/E1/1.jpg' /> </div>
          <div style=" position: absolute; top: 113px; left: 467px; "><input id='0' /></div>
          <div style=" position: absolute; top: 166px; left: 510px; "><input id='1' /></div>
          <div style=" position: absolute; top: 220px; left: 529px; "><input id='2' /></div>
          <div style=" position: absolute; top: 273px; left: 431px; "><input id='3' /></div>
          <div style=" position: absolute; top: 326px; left: 383px; "><input id='4' /></div>
          <div style=" position: absolute; top: 380px; left: 401px; "><input id='5' /></div>
          <div style=" position: absolute; top: 433px; left: 483px; "><input id='6' /></div>


        </div>
        `,
        answer: [
          "This boy was good.",
          "We were in the park.",
          "The babies weren't sad.",
          "They were hungry.",
          "Mom was dry.",
          "She wasn't wet.",
          "Billy was little then.",
        ],
      },
    ],
  },
  2: { // Exercise num
    unit: 'Unit 12',
    id: 'WB3-U12-P81-E2',
    audio: 'img/FriendsPlus/Page81/Audio/audio-e2-p81.mp3',
    video: '',
    component: T6,
    stylesTextInput: { backgroundColor: 'transparent', border: 'none', padding: 0 },
    exerciseKey: 'img/FriendsPlus/Page81/E2/Key/answerKey.png',
    inputSize: 92,
    // titleImage: "img/FriendsPlus/Page60/E1/1.jpg",
    titleQuestion: [{ num: '2', title: 'Listen, look, and write. <headphone name="23" src="img/FriendsPlus/Page81/Audio/tieude-e2-p81.mp3"></headphone>  ' }],
    questionImage: [],
    questions: [
      {
        title: `
        <div style=" position: relative; ">
          <div> <img src='img/FriendsPlus/Page81/E2/1.jpg' /> </div>
          <div style=" position: absolute; top: 119px; left: 536px; "><input id='0' /></div>
          <div style=" position: absolute; top: 172px; left: 489px; "><input id='1' /></div>
          <div style=" position: absolute; top: 172px; left: 722px; "><input id='2' /></div>
          <div style=" position: absolute; top: 226px; left: 806px; "><input id='3' /></div>
          <div style=" position: absolute; top: 280px; left: 660px; "><input id='4' /></div>
          <div style=" position: absolute; top: 332px; left: 488px; "><input id='5' /></div>
          <div style=" position: absolute; top: 386px; left: 513px; "><input id='6' /></div>
          <div style=" position: absolute; top: 439px; left: 603px; "><input id='7' /></div>
          <div style=" position: absolute; top: 492px; left: 547px; "><input id='8' /></div>
        </div>
        `,
        answer: [
          "was",
          "weren't",
          "were",
          "were",
          "wasn't",
          "was",
          "was",
          "were",
          "was",
        ],
      },
    ],
  },




}
export default json;